<!--The content below is only a placeholder and can be replaced.-->
<router-outlet></router-outlet>
<app-version-popup></app-version-popup>
<app-announcement-host></app-announcement-host>
